import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import {
  postNotificationDestinations,
  PostNotificationDestinationsRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useCreateNotificationDestinationsMutation = () => {
  return useMutation({
    mutationFn: (data: PostNotificationDestinationsRequest) => postNotificationDestinations(data),
    onError(error: BaseErrorResponse, data) {
      logSentryError('Error from useCreateWebhookDestinationsMutation', error, data)
    },
  })
}
